import type { ReactNode } from 'react';

export const symbol_speed_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M542-340q26-26 24.5-61.5T536-456q-67-44-135-89l-136-90q-11-7-19.5 1t-1.5 19q45 68.36 90 136.18Q379-411 424-344q19 29 55 30t63-26ZM192-160q-18.27 0-33.64-8.5Q143-177 133-193q-26-47-39.5-99.17T80-399q0-51 13.5-99.5T133-592q6-11 17.83-12 11.82-1 22.17 7 10 8 12 20t-5 23q-22 35-31 74.47-9 39.48-9 80.53 0 48.16 11.5 93.58T188-220h584q24-41 36-86.07 12-45.08 12-92.93 0-141-98.5-241T482-740q-27 0-53 5t-51 13q-12.87 5-24.93-.5Q341-728 336-740t-.5-23.5Q340-775 352-779q34-11 67-16t65-5q82.27 0 154.14 32Q710-736 764-681.5T849-554q31 73 31 155 0 54.69-14 106.35Q852-241 826-193q-9 16-24.78 24.5Q785.44-160 768-160H192Zm293-235Z"
		/>
	</svg>
);
